import http from "../services/http.common";

function fetchToken() {
  return {
    headers: {
      'Authorization': localStorage.getItem('token') || '---',
    }
  }
}

class VCDMSService {
  getAll(ApiName) {
    return http.post(ApiName, {}, fetchToken());
  }

  getById(ApiName, id) {
    return http.post(`${ApiName}/${id}`, {}, fetchToken());
  }

  getByBoj(ApiName, data) {
    return http.post(ApiName, data, fetchToken());
  }

  CreateUpdate(ApiName, data) {
    return http.post(ApiName, data, fetchToken());
  }

  getBackup(ApiName) {
    return http.get(ApiName, {
      responseType: 'blob',
      headers: {
        "Authorization": localStorage.getItem('token') || '---',
      },
    });
  }

  uploadBackup(ApiName, data) {
    let formdata = new FormData();
    formdata.append("user", data.user)
    // add for the convert api 
    if (data.layout_id)
      formdata.append("layout_id", data.layout_id)
    formdata.append("opfor", data.opfor)
    formdata.append("username", data.username)


    formdata.append("file", data.file);
    return http.post(ApiName, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": localStorage.getItem('token') || '---',
      },
      processData: false,
      timeout: 300000,
    })
  }

  uploadbackupForSingleCustomer(ApiName, data) {
    let formdata = new FormData();
    formdata.append("user", data.user)
    formdata.append("file", data.file);
    return http.post(ApiName, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": localStorage.getItem('token') || '---',
      },
      processData: false,
      timeout: 300000,
    })
  }

  getBackupForSingleUser(ApiName, id, userName) {
    return http.post(`${ApiName}/:${id}`, userName, fetchToken());
  }
  update(ApiName, id, data) {
    return http.put(`${ApiName}/${id}`, data, fetchToken());
  }
  getByUsername(ApiName, data) {
    return http.post(ApiName, data, fetchToken());
  }
  SetByUsername(ApiName, data) {
    return http.put(ApiName, data, fetchToken());
  }
  SetPassword(ApiName, data) {
    return http.put(ApiName, data, fetchToken());
  }
  verifyPassword(ApiName, data) {
    return http.post(ApiName, data, fetchToken());
  }
  deleteByID(ApiName, id) {
    return http.delete(`${ApiName}/${id}`, {}, fetchToken());
  }
  get(ApiName) {
    return http.get(`${ApiName}`, fetchToken());
  }

  uploadFileOnDir(ApiName, data) {
    let formdata = new FormData();
    formdata.append("file", data.file);
    if (data.userID) {
      formdata.append("userID", data.userID);
    }
    return http.post(ApiName, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": localStorage.getItem('token') || '---',
      },
      processData: false,
      timeout: 300000,
    });
  }


  uploadFileNas(ApiName, file, storage, setUploadProgress, folderName) {
    let formData = new FormData();
    let userId = localStorage.getItem("UserId")
    formData.append("file", file);
    formData.append("userId", userId)
    formData.append("storage", storage)
    formData.append("folderName", folderName)

    console.log("Formdata : ", formData)

    // formData.append('fileName', file.name); // Optional
    // // formData.append('path', curentPath); // Optional additional data
    // formData.append('create_parents', true); // Optional additional data

    return http.post(ApiName, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": localStorage.getItem('token') || '---',
      },
      processData: false,
      onUploadProgress: (e) => {
        const p = Math.round((e.loaded * 100) / e.total);
        setUploadProgress(old => old.map(ele => ele.fileName === file.name ? { ...ele, percent: p } : ele))
      },
      timeout: 300000, // Optional timeout
    })
  }

  uploadFile(ApiName, data) {
    let formdata = new FormData();
    formdata.append("file", data.file);
    formdata.append("userID", data.userID);
    return http.post(ApiName, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": localStorage.getItem('token') || '---',
      },
      processData: false,
      timeout: 300000,
    });
  }
  delete(ApiName, data) {
    return http.post(ApiName, data, fetchToken());
  }
}

export default new VCDMSService();
